import { render, staticRenderFns } from "./OldCart.vue?vue&type=template&id=7650e04a&"
import script from "./OldCart.vue?vue&type=script&lang=js&"
export * from "./OldCart.vue?vue&type=script&lang=js&"
import style0 from "./OldCart.vue?vue&type=style&index=0&id=7650e04a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports